import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import { buildCategoryRows, formatCost } from './costHelpers';

export default function IpfCategoryTable({ title, records, days, category }) {
  const { rows, totals } = useMemo(() => buildCategoryRows(records, category, days), [records, category, days]);

  return (
    <div className="cost-ipf-table-wrapper" style={{ borderRadius: 6, padding: 16 }}>
      <h4 className="cost-ipf-table-title" style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700, textAlign: 'center', textTransform: 'uppercase' }}>
        {title}
      </h4>
      <Table striped bordered hover size="sm" responsive>
        <thead>
          <tr>
            <th>Date</th>
            <th>Count</th>
            <th>Total Cost</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={row.date}>
              <td>{dayjs(row.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}</td>
              <td>{row.count}</td>
              <td>{formatCost(row.totalCost)}</td>
            </tr>
          ))}
          <tr style={{ fontWeight: 700 }}>
            <td>{totals.date}</td>
            <td>{totals.count}</td>
            <td>{formatCost(totals.totalCost)}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

IpfCategoryTable.propTypes = {
  title: PropTypes.string.isRequired,
  records: PropTypes.array.isRequired,
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
  category: PropTypes.string.isRequired
};
